// Theme Colors Configuration
// This file provides backwards compatibility with the old colors import
// while the new theme system uses ThemeContext for dynamic theme switching

import { darkTheme, lightTheme, legacyColors, createThemeObject } from './themes';

// Export dark theme as default for backwards compatibility
export const colors = {
  ...darkTheme,
  legacy: legacyColors,
  bg: darkTheme.bgCard, // Add bg alias for backwards compatibility
};

// Theme object for easy import (uses dark theme by default for backwards compatibility)
export const theme = createThemeObject(darkTheme);

// Re-export theme utilities
export { darkTheme, lightTheme, legacyColors, createThemeObject } from './themes';

export default theme; 